import React, { createContext, useState, useCallback } from 'react';
import { toast } from 'react-toastify';
import { getComments, changeCommentStatus, replyToComment, deleteComment } from '../services/api';

export const CommentContext = createContext();

export const CommentProvider = ({ children }) => {
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchComments = useCallback(async (status = null) => {
    setLoading(true);
    setError(null);
    try {
      const response = await getComments(status);
      setComments(response.data);
    } catch (err) {
      const errorMessage = err.response?.data?.message || 'خطا در دریافت نظرات';
      setError(errorMessage);
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  }, []);

  const updateCommentStatus = useCallback(async (id, status) => {
    setLoading(true);
    setError(null);
    try {
      const response = await changeCommentStatus(id, { status });
      setComments((prev) => prev.map((comment) => (comment.id === id ? response.data : comment)));
      toast.success('وضعیت نظر با موفقیت تغییر کرد');
      return response.data;
    } catch (err) {
      const errorMessage =
        err.response?.status === 404
          ? 'نظر مورد نظر یافت نشد'
          : err.response?.data?.message || 'خطا در تغییر وضعیت نظر';
      setError(errorMessage);
      toast.error(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const addReply = useCallback(async (id, reply) => {
    setLoading(true);
    setError(null);
    try {
      const response = await replyToComment(id, { reply });
      setComments((prev) => prev.map((comment) => (comment.id === id ? response.data : comment)));
      toast.success('پاسخ با موفقیت ثبت شد');
      return response.data;
    } catch (err) {
      const errorMessage =
        err.response?.status === 404
          ? 'نظر مورد نظر یافت نشد'
          : err.response?.data?.message || 'خطا در ثبت پاسخ';
      setError(errorMessage);
      toast.error(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const removeComment = useCallback(async (id) => {
    setLoading(true);
    setError(null);
    try {
      await deleteComment(id);
      setComments((prev) => prev.filter((comment) => comment.id !== id));
      toast.success('نظر با موفقیت حذف شد');
    } catch (err) {
      const errorMessage =
        err.response?.status === 404
          ? 'نظر مورد نظر یافت نشد'
          : err.response?.data?.message || 'خطا در حذف نظر';
      setError(errorMessage);
      toast.error(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return (
    <CommentContext.Provider
      value={{
        comments,
        loading,
        error,
        fetchComments,
        updateCommentStatus,
        addReply,
        removeComment,
      }}
    >
      {children}
    </CommentContext.Provider>
  );
};